const closeAllPopovers = () => {
  Array.from(document.querySelectorAll('[popover]')).forEach((popover) => {
    if (typeof popover.hidePopover === 'function') popover.hidePopover();
  });
};

export { closeAllPopovers };
